export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00797.03edaaf5.png";